import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Converts a snake_case string to Title Case
 */
export function snakeToTitleCase(str: string) {
  return str
    .toLowerCase() // Convert the entire string to lowercase
    .split('_') // Split the string into an array of words
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the array back into a single string
}
